import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconArrowRightTop.tsx
const IconArrowRightTop = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsx("path", {
		fill: "currentColor",
		d: "m16.004 9.414-8.607 8.607-1.414-1.414L14.59 8H7.004V6h11v11h-2z"
	})]
});
var IconArrowRightTop_default = forwardRef(IconArrowRightTop);
//#endregion
export { IconArrowRightTop_default as default };
